import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ContactService } from 'src/app/private/services/contact.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-contact',
  imports: [SharedModule],
  templateUrl: './delete-contact.component.html',
  styleUrl: './delete-contact.component.scss'
})
export class DeleteContactComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() editContactData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: ContactService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.middle_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete(){
    this.isLoading = true;

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      id: this.editContactData.id
    }

    this.api.deleteContact(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Contact deleted successfully'});
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
        this.isLoading = false;
      }
    }
    );

  }

}
